var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDrivingLicense = function SvgDrivingLicense(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "tansparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M40 8.31H8c-2.22 0-3.98 1.78-3.98 4l-.02 24c0 2.22 1.78 4 4 4h32c2.22 0 4-1.78 4-4v-24c0-2.22-1.78-4-4-4m-.232 13.816H26.74v-3h13.03v3zm0 5H26.74v-3h13.03v3zm0 2v3H26.74v-3h13.03zm-23.72-3.839c1.074 0 2.132.126 3.174.379 1.042.252 2.068.63 3.077 1.136.472.244.85.598 1.135 1.062.286.464.428.973.428 1.526v2.736H8.232V29.39c0-.553.143-1.062.428-1.526a2.846 2.846 0 0 1 1.135-1.062 14.523 14.523 0 0 1 3.077-1.136c1.042-.253 2.1-.379 3.175-.379zm0-8.792c1.074 0 1.994.383 2.759 1.148.765.765 1.148 1.685 1.148 2.76 0 1.075-.383 1.994-1.148 2.76-.765.765-1.685 1.148-2.76 1.148-1.074 0-1.994-.383-2.76-1.148-.765-.766-1.147-1.685-1.147-2.76 0-1.075.382-1.995 1.147-2.76.766-.765 1.686-1.148 2.76-1.148z"
  }))));
};
export default SvgDrivingLicense;